<template>
    <div class="video-admin">
        <div class="video-admin-search">
            <search-box>
                <template slot="search-box-btn">
                    <div class="btn">
                        <el-button type="primary" icon="el-icon-search"> 搜索</el-button>
                        <el-button type="primary"><i class="el-icon-plus"></i> 新增视频</el-button>
                    </div>
                </template>
            </search-box>
        </div>
        <div class="video-admin-table">
            <el-table :data="tableData" style="width: 100%;">
                <el-table-column prop="date" label="视频名称" width="180">
                </el-table-column>
                <el-table-column prop="name" label="所属动作" width="180">
                </el-table-column>
                <el-table-column prop="address" label="教练">
                </el-table-column>
                <el-table-column prop="address" label="媒资ID">
                </el-table-column>
                <el-table-column prop="address" label="oss地址">
                </el-table-column>
                <el-table-column prop="date" label="添加时间">
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button size="mini" @click="handleDownload(scope.$index, scope.row)">下载</el-button>
                        <el-button size="mini" type="danger" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination class="pagination" :page-sizes="[10, 20, 30, 50, 100]" :current-page="pagination.page"
                :page-size="pagination.pageSize" :total="pagination.total" layout="total, prev, pager, next"
                @size-change="handleSizeChange" @current-change="handleCurrentChange" />
        </div>

    </div>
</template>
  
<script>
import SearchBox from "../../components/searchBox.vue"
export default {
    data () {
        return {
            tableData: [{
                date: '2016-05-02',
                name: '王小虎王小虎王小虎王小虎',
                address: '上海市普陀区金沙江路 1518 弄'
            }, {
                date: '2016-05-04',
                name: '王小虎',
                address: '上海市普陀区金沙江路 1517 弄'
            }, {
                date: '2016-05-01',
                name: '王小虎',
                address: '上海市普陀区金沙江路 1519 弄'
            }, {
                date: '2016-05-03',
                name: '王小虎',
                address: '上海市普陀区金沙江路 1516 弄'
            }],
            pagination: {
                page: 1,
                pageSize: 10,
                total: 10,
            },
        }
    },
    components: {
        SearchBox
    },
    methods: {
        handleSizeChange (val) {
            console.log(val)
        },
        handleCurrentChange (val) {
            console.log(val)
        },
        // 下载
        handleDownload (index, row) {
            console.log(index, row, "MMMMMMMMMM")
        },
        // 编辑
        handleEdit (index, row) {

        }
    },
    mounted () {
    }

}
</script>
  
<style lang="scss" scoped>
.video-admin {
    width: 100%;
    height: auto;

    &-search {
        width: 100%;
        padding-bottom: 10px;
        border-bottom: 1px solid #f9f9f9;
    }

    &-table {
        width: 100%;
    }

    /deep/ .pagination {
        width: 100%;
        background: #fff;
        position: absolute;
        right: 0;
        bottom: -25px;
    }
}
</style>